module.exports = "/assets/data/6fc3c97d646b60eb3684a9a20d33cd3f-SN26.data.json";